import React, { useRef } from "react";
import { IDSAlert, IDSButton } from "@inera/ids-react";
import { formatDateTimeNoSeconds } from "../../utils/dateTime";

const DEFAULT_INFO_MESSAGE =
  "Här kan du ladda upp bilagor i form av .zip-filer (max 10 MB). Bilagorna kommer att vara synliga för granskare tillsammans med dina svar. Du kan ladda upp, ta bort och byta ut bilagor så länge formuläret inte är inlämnat.";

function AttachmentUploadSection({
  onFileUpload,
  uploadError,
  attachments,
  onDeleteAttachment,
  onDownloadAttachment,
  heading = "Bilagor",
  infoHeadline = "Info",
  infoMessage = DEFAULT_INFO_MESSAGE,
  accept = ".zip",
}) {
  const fileInputRef = useRef(null);

  return (
    <div className="ids-mb-6">
      <div>
        <IDSAlert collapsableHeadline="" headline={<h2>{infoHeadline}</h2>} type="info">
          <span>{infoMessage}</span>
        </IDSAlert>
      </div>

      <h3 className="ids-heading-s ids-mb-2">{heading}</h3>

      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={onFileUpload}
        style={{ display: "none" }}
      />

      <IDSButton
        active
        aria-label="Ladda upp bilaga"
        icon="plus"
        iconButton
        type="button"
        onClick={() => fileInputRef.current?.click()}
      />

      {uploadError && (
        <div className="ids-mt-2">
          <IDSAlert type="error"><p>{uploadError}</p></IDSAlert>
        </div>
      )}

      {attachments.length > 0 && (
        <ul className="ids-mt-2">
          {attachments.map((att) => (
            <li
              key={att.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                marginBottom: "0.25rem",
              }}
            >
              {onDownloadAttachment ? (
                <button
                  type="button"
                  onClick={() => onDownloadAttachment(att)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "var(--ids-palette-primary-40)",
                    cursor: "pointer",
                    textDecoration: "underline",
                    padding: 0,
                  }}
                >
                  {att.fileName}
                </button>
              ) : (
                <span>{att.fileName}</span>
              )}
              <span style={{ color: "var(--ids-palette-neutral-50)", marginLeft: "0.5rem" }}>
                ({(att.fileSize / 1024).toFixed(0)} KB)
                {att.createdAt && ` · Uppladdad ${formatDateTimeNoSeconds(att.createdAt)}`}
              </span>
              <IDSButton
                size="s"
                secondary
                type="button"
                onClick={() => onDeleteAttachment(att.id)}
              >
                Ta bort
              </IDSButton>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AttachmentUploadSection;